import { render } from "./Header.vue?vue&type=template&id=0a7e3e84&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=0a7e3e84&lang=scss&scoped=true"

import exportComponent from "D:\\www\\gits\\g-vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7e3e84"]])

export default __exports__